import React from "react";
import { Button } from "react-bootstrap";

const Pagination = ({ pageNumber, totalCount, pageSize, onPageChange }) => {
  const totalPages = Math.ceil(totalCount / pageSize);

  const getPageNumbers = () => {
    let pages = [];
    if (totalPages <= 7) {
      // Show all pages if not too many
      for (let i = 1; i <= totalPages; i++) pages.push(i);
    } else {
      // Always show first, last, current, neighbors
      pages.push(1);
      if (pageNumber > 3) pages.push("...");

      let start = Math.max(2, pageNumber - 1);
      let end = Math.min(totalPages - 1, pageNumber + 1);

      for (let i = start; i <= end; i++) pages.push(i);

      if (pageNumber < totalPages - 2) pages.push("...");
      pages.push(totalPages);
    }
    return pages;
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-3 gap-2">
      {/* First Page */}
      <Button
        variant="light"
        disabled={pageNumber === 1}
        onClick={() => onPageChange(1)}
      >
        ⏮
      </Button>

      {/* Previous */}
      <Button
        variant="light"
        disabled={pageNumber === 1}
        onClick={() => onPageChange(pageNumber - 1)}
      >
        ◀
      </Button>

      {/* Page Numbers */}
      {getPageNumbers().map((num, idx) =>
        num === "..." ? (
          <span key={idx} className="mx-1">
            ...
          </span>
        ) : (
          <Button
            key={idx}
            variant={num === pageNumber ? "primary" : "light"}
            onClick={() => onPageChange(num)}
          >
            {num}
          </Button>
        )
      )}

      {/* Next */}
      <Button
        variant="light"
        disabled={pageNumber === totalPages}
        onClick={() => onPageChange(pageNumber + 1)}
      >
        ▶
      </Button>

      {/* Last Page */}
      <Button
        variant="light"
        disabled={pageNumber === totalPages}
        onClick={() => onPageChange(totalPages)}
      >
        ⏭
      </Button>
    </div>
  );
};

export default Pagination;
